<template lang="pug">
.memory-study_cover.color_mask
  .memory-study.color_bg_2(:style="`top:${coverTop}`")
    .header
      .close-btn(@click="closeWriteBoard")
      j-switch-btn.memory-switch_btn(:isActive="false", label="默写", @j-switch="switchMemory")
    .memory-switch_con(v-show="false")
      j-switch-btn.memory-switch_btn(:isActive="false", label="默写", @j-switch="switchMemory")
    .study-swiper_list
      .swiper_item-next(@click="slideTo(1)")
      .swiper_item-pre(@click="slideTo(-1)")
      .swiper-container
        .swiper-wrapper
          template(v-for="(item, index) in memoryList")
            .swiper-slide.swiper_item
              .swiper_item-header
                .romaji
                  .romaji-text.color_text_1(@click="playVoice(item.hiragana, index)")
                    span {{item.romaji}}
                    .romaji-voice(:class="activeIndex === index?'voicing':''")
                  .romaji-title.color_text_3 罗 马 音
              .siwper_item-content
                .write-memory_cover.color_label_2(v-show="isMemoryMode")
                  .write-memory_notice
                    .incapable-icon
                    .incapable-btn.color_divider_2.color_text_2(@click="seeSeconds") 不会写，偷看一眼
                .study-write_imgs
                  .study-imgs_con
                    img.study-img(
                      :src="getMemoryImg(index, 'hiragana', appMode, imgMaxHeight)",
                      :style="`max-height:${imgMaxHeight}px;`"
                    )
                  .study-imgs_con.study-imgs_last
                    img.study-img(
                      :src="getMemoryImg(index, 'katakana', appMode, imgMaxHeight)",
                      :style="`max-height:${imgMaxHeight}px;`"
                    )
                .apply-example(v-if="item.example.text !== ''")
                  .title.color_text_3 应用实例
                  .paraphrasing-con
                    .paraphrasing-detail.color_text_2(@click="wordDetails(item.example)") 详细释义
                    .text-con
                      span.apply.color_text_1 {{item.example.text}}
                      span.paraphrasing.color_text_3 {{item.example.paraphrase}}
      .write-con
        .title.color_text_3 书写练习区
        .write-area
          writing-board(ref="writingBoardRef")
</template>

<script>
import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  nextTick,
  watch,
  computed,
} from 'vue';
import { useStore } from 'vuex';
import { Howl } from 'howler';
import JSwitchBtn from '@/components/JSwitchBtn.vue';
import WritingBoard from '@/components/WritingBoard.vue';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.css';
import voiceless from '@/utils/voiceless';
import detectUtil from '@/utils/detectOrient';

export default defineComponent({
  name: 'MemoryStudy',
  components: {
    JSwitchBtn,
    WritingBoard,
  },
  props: {
    data: Object,
  },
  setup(props, context) {
    const store = useStore();
    const studySwiper = ref(null);
    const currentMemoryData = ref(null);
    const slideIndex = ref(0);
    const isMemoryMode = ref(false);
    const writingBoardRef = ref(null);
    const imgMaxHeight = ref(0);
    const katakanaImg = ref(''); // 平假名
    const hiraganaImg = ref(''); // 片假名
    const activeIndex = ref(-1); // 正在播放的单词索引
    const appMode = computed(() => store.state.appMode);
    const coverTop = ref('1.68rem');
    let playTimerId = '';
    let sound = new Howl({
      html5: true,
      src: [''],
      preload: true,
      volume: 1,
    });
    let seeSecondsTimer = null;
    let initIndex = 0;

    watch(() => props.data, (newValue) => {
      currentMemoryData.value = newValue;
    });

    let voiceLessData = [];
    voiceless.row.value.forEach((item) => {
      const dataItem = item.filter((d) => d.hiragana);
      voiceLessData = voiceLessData.concat(dataItem);
    });
    const memoryList = reactive(voiceLessData);
    console.log('props.data.hiragana==', props.data.rowValueItem.hiragana);
    initIndex = voiceLessData.findIndex((item) => {
      const { hiragana } = item;
      console.log('hiragana==', hiragana);
      return hiragana === props.data.rowValueItem.hiragana;
    });
    slideIndex.value = initIndex;
    console.log('slideIndex===', slideIndex.value);

    // 监听滑动 index 变化及暗夜模式变化
    watch([slideIndex, appMode, imgMaxHeight], (newValues) => {
      const index = newValues[0];
      const mode = newValues[1];
      const imgHeight = newValues[2];
      console.log('imgHeight==', imgHeight);
      const publicPath = process.env.VUE_APP_PUBLIC;
      const { hiragana, katakana } = memoryList[index]; // 平假名 & 片假名
      const suffix = mode === 'dark' ? '_dark' : '';
      const imgSize = imgHeight <= 140 ? '_small' : '';
      hiraganaImg.value = `${publicPath}static/hiragana/${hiragana}${imgSize}${suffix}.png`;
      katakanaImg.value = `${publicPath}static/katakana/${katakana}${imgSize}${suffix}.png`;
    }, { immediate: true });

    /*
    * type: hiragana || katakana
    * mode: light || dark
    * */
    const getMemoryImg = (index, type, mode, imgHeight) => {
      const suffix = mode === 'dark' ? '_dark' : '';
      const imgSize = imgHeight <= 140 ? '_small' : '';
      // console.log('imgSize==', imgSize);
      const publicPath = process.env.VUE_APP_PUBLIC;
      const name = memoryList[index][type]; // 平假名 & 片假名
      return `${publicPath}static/${type}/${name}${imgSize}${suffix}.png`;
    };

    // 应用实例字段类似：さくら⓪桜，但跳转查词结果页时是提取⓪后半部分
    const getValidText = (text) => {
      const textArr = text.split('');
      const validTextArr = [];
      const noteFlagArr = ['⓪', '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨'];
      for (let i = textArr.length - 1; i > 0; i -= 1) {
        const textI = textArr[i];
        if (noteFlagArr.includes(textI)) {
          break;
        } else {
          validTextArr.push(textI);
        }
      }
      return validTextArr.reverse().join('');
    };

    const switchMemory = (isOpen) => {
      if (seeSecondsTimer) {
        clearTimeout(seeSecondsTimer);
        seeSecondsTimer = null;
      }
      isMemoryMode.value = isOpen;
    };

    const closeWriteBoard = () => {
      context.emit('write-board-close');
    };

    const slideChangeTransitionEnd = (swiper) => {
      console.log('slideChangeTransitionEnd==', swiper, swiper.activeIndex);
      nextTick(() => {
        studySwiper.value.update();
        slideIndex.value = swiper.activeIndex;
      });
    };

    const slideTo = (step, speed = 384) => {
      if (slideIndex.value + step >= voiceLessData.length) {
        slideIndex.value = 0;
      } else if (slideIndex.value + step < 0) {
        slideIndex.value = voiceLessData.length - 1;
      } else {
        slideIndex.value += step;
      }
      studySwiper.value.slideTo(slideIndex.value, speed, false);
      writingBoardRef.value.clear();
    };

    // 偷看一眼
    const seeSeconds = () => {
      isMemoryMode.value = false;
      if (seeSecondsTimer) {
        clearTimeout(seeSecondsTimer);
        seeSecondsTimer = null;
      }
      seeSecondsTimer = setTimeout(() => {
        isMemoryMode.value = true;
      }, 2000);
    };

    const playVoice = (hiragana, index) => {
      const audioSrc = `https://dict.youdao.com/dictvoice?audio=${hiragana}&le=jap`;
      console.log('playVoice==', audioSrc);
      // eslint-disable-next-line
      if (sound._src[0] === audioSrc) {
        return;
      }
      // eslint-disable-next-line
      window._rlog.push([
        '_trackCustom',
        'japanese50',
        [
          ['aciton', 'syllabary_pronounce'],
          ['source', 'study'],
        ],
      ]);
      if (playTimerId) {
        clearTimeout(playTimerId);
        playTimerId = '';
      }
      sound = new Howl({
        html5: true,
        src: [audioSrc],
        preload: true,
        volume: 1,
      });
      activeIndex.value = index;
      sound.play();
      playTimerId = setTimeout(() => {
        // eslint-disable-next-line
        sound._src = [''];
        activeIndex.value = -1;
      }, 1000);
    };

    const wordDetails = (example) => {
      const { text = '' } = example;
      const word = getValidText(text);
      console.log('getValidText==', word);
      const dictAppleStore = 'https://apps.apple.com/cn/app/%E7%BD%91%E6%98%93%E6%9C%89%E9%81%93%E8%AF%8D%E5%85%B8-%E9%99%AA%E4%BD%A0%E7%9C%8B%E4%B8%96%E7%95%8C/id353115739';
      const dictAndroidStore = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.youdao.dict&from=singlemessage';
      const deeplink = `yddict://m.youdao.com/dict?q=${encodeURIComponent(word)}&le=jap&lanFrom=ja&lanTo=zh-CHS`;
      // eslint-disable-next-line
      window._rlog.push([
        '_trackCustom',
        'japanese50',
        [
          ['aciton', 'syllabary_application'],
        ],
      ]);
      if (window.ydk && window.ydk.isYD && window.ydk.openURLScheme) {
        window.ydk.openURLScheme({ url: deeplink });
      } else if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        window.location.href = dictAppleStore;
      } else {
        window.location.href = dictAndroidStore;
      }
    };

    onMounted(() => {
      const deviceMode = detectUtil.detectOrient();
      window.addEventListener('orientationchange', () => {
        window.location.reload();
      });
      nextTick(() => {
        const voicePics = document.querySelector('#voicePics');
        const subTab = document.querySelector('.sub-tab');
        let top = window.getComputedStyle(voicePics).paddingTop;
        top = parseFloat(top) - 16 - subTab.offsetHeight;
        coverTop.value = `${top}px`;
        studySwiper.value = new Swiper(
          '.swiper-container',
          {
            initialSlide: 0,
            on: {
              init: () => {
                // swiper dom 初始化后，计算剩余高度
                const memoryStudyEle = document.querySelector('.memory-study');
                const swiperListEle = document.querySelector('.study-swiper_list');
                const fatherRect = memoryStudyEle.getBoundingClientRect();
                const childRect = swiperListEle.getBoundingClientRect();
                const padding = childRect.top - fatherRect.top + 32; // 底部留 32px 间距
                const imgHeight = (fatherRect.height - childRect.height) - padding;
                // 若是平板横屏则图片高度取 imgHeight，写字板高度为图片高度加不包含 32px 的间距
                if (deviceMode === 'landscape') {
                  imgMaxHeight.value = imgHeight;
                  writingBoardRef.value.init(imgHeight + padding - 32);
                // 其他情况按比例取
                } else {
                  imgMaxHeight.value = imgHeight * 0.4; // 图片高度占剩余0.4
                  writingBoardRef.value.init(imgHeight * 0.6); // 手写板高度占剩余0.6
                }
              },
              slideChangeTransitionEnd: (swiper) => {
                slideChangeTransitionEnd(swiper);
                writingBoardRef.value.clear();
              },
            },
          },
        );
        slideTo(0, 0);
      });
    });

    return {
      appMode,
      isMemoryMode,
      memoryList,
      switchMemory,
      closeWriteBoard,
      hiraganaImg,
      katakanaImg,
      writingBoardRef,
      imgMaxHeight,
      activeIndex,
      coverTop,
      slideTo,
      seeSeconds,
      playVoice,
      wordDetails,
      getMemoryImg,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .memory-study_cover
    position fixed
    z-index 3
    top 0
    left 0
    width 100%
    height 100%
  .memory-study
    position fixed
    z-index 4
    top 1.68rem
    left 0
    right 0
    bottom 0
    padding 0.4rem
    border-top-left-radius 0.32rem
    border-top-right-radius 0.32rem
    background #FFFFFF url("../assets/bg_jp_gradient@2x.png") 50% 0 no-repeat
    background-size 100% auto
    .header
      display flex
      flex-direction column
      align-items flex-end
    .close-btn
      width 0.48rem
      height 0.48rem
      background url("../assets/nav_close.png") 50% 50% no-repeat
      background-size contain
      margin-bottom 0.2rem
    .memory-switch_con
      height 0.46rem
      /*.memory-switch_btn*/
      /*  float right*/
    .title
      font-size 0.24rem
      line-height 0.36rem
      margin-bottom 0.16rem
      text-align left
    .apply-example
      margin-top 0.48rem
  .study-swiper_list
    position relative
    z-index -1
    .swiper_item-next, .swiper_item-pre
      width 0.6rem
      height 0.6rem
      position absolute
      z-index 2
      top 0.32rem
      background url("../assets/ic_jap_popup_next.png") 50% 50% no-repeat
      background-size contain
    .swiper_item-next
      right 0
    .swiper_item-pre
      left 0
      background url("../assets/ic_jap_popup_pre.png") 50% 50% no-repeat
      background-size contain
    .swiper_item-header
      height 1.2rem
      margin-bottom 0.32rem
      text-align center
      .romaji
        display inline-block
        .voicing
          animation audioPlaying 0.8s infinite
          -webkit-animation audioPlaying 0.8s infinite
        .romaji-text
          display inline-block
          height 0.96rem
          font-weight bolder
          font-size 0.96rem
          line-height 0.96rem
          margin-bottom 0.04rem
          position relative
          .romaji-voice
            width 0.48rem
            height 0.48rem
            border-radius 0.12rem
            background #F4F5F7 url("../assets/ic_result_voice_.png") 50% 50% no-repeat
            background-size contain
            position absolute
            top 50%
            right -0.72rem
            transform translate(0, -50%)
        .romaji-title
          font-size 0.24rem
          line-height 0.28rem
    .siwper_item-content
      position relative
      font-size 0
      letter-spacing 0
      text-align center
      margin-bottom 0.48rem
      .write-memory_cover
        position absolute
        border-radius 0.32rem
        z-index 1
        top -0.1rem
        left -0.1rem
        right -0.1rem
        bottom -0.1rem
        .write-memory_notice
          position absolute
          top 50%
          left 50%
          transform translate(-50%, -50%)
          .incapable-icon
            width 1.6rem
            height 1.6rem
            margin 0 auto 0.08rem auto
            background url("../assets/incapable-icon.png") 50% 50% no-repeat
            background-size contain
          .incapable-btn
            width 2.84rem
            height 0.64rem
            line-height 0.64rem
            border-radius 0.4rem
            font-size 0.28rem
            margin 0 auto
      .study-write_imgs
        text-align center
        font-size 0
        .study-imgs_con
          box-sizing border-box
          padding 0 0.26rem
          display inline-block
          margin-right 0.3rem
          border-radius 0.32rem
          max-width 45%
          overflow hidden
          background rgba(244, 245, 247, 0.6)
          .study-img
            display block
            margin 0 auto
            width auto
            max-height 2.12rem
            border-radius 0.32rem
        .study-imgs_last
          margin-right 0
    .paraphrasing-con
      height 0.4rem
      line-height 0.4rem
      font-size 0.24rem
      text-align left
      .paraphrasing-detail
        float right
        height 0.4rem
        line-height 0.4rem
        padding-right 0.4rem
        background url("../assets/ic_arrows.png") right 0.02rem top 50% no-repeat
        background-size 0.32rem 0.32rem
      .text-con
        margin-right 1.6rem
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
        .apply
          font-family NotoSerifJP
          margin-right 0.08rem
</style>
<style lang="stylus" scoped>
.dark
  .memory-study
    background #141517 url("../assets/bg_jp_gradient_dark@2x.png") 50% 0 no-repeat
    background-size 100% auto
  .study-swiper_list
    .swiper_item-header
      .romaji
        .voicing
          animation audioPlayingDark 0.8s infinite
          -webkit-animation audioPlayingDark 0.8s infinite
        .romaji-text
          .romaji-voice
            background #2F2F30 url("../assets/ic_result_voice_dark.png") 50% 50% no-repeat
            background-size contain
    .paraphrasing-con
      .paraphrasing-detail
        background url("../assets/ic_arrows_dark.png") right center no-repeat
        background-size 0.32rem 0.32rem
    .swiper_item-next
      background url("../assets/ic_jap_popup_next_dark.png") 50% 50% no-repeat
      background-size contain
    .swiper_item-pre
      background url("../assets/ic_jap_popup_pre_dark.png") 50% 50% no-repeat
      background-size contain
  .memory-study
    .close-btn
      background url("../assets/nav_close_dark.png") 50% 50% no-repeat
      background-size contain
  .siwper_item-content
    .study-write_imgs
      .study-imgs_con
        background rgba(47, 48, 48, 0.6)
    .write-memory_cover
      .write-memory_notice
        .incapable-icon
          background url("../assets/incapable-icon-dark.png") 50% 50% no-repeat
          background-size contain
</style>
<style lang="stylus" scoped>
.landscape
  .memory-study_cover
    /deep/
      .siwper_item-content
        width 48%
        .write-memory_cover
          top 0
          left 0
          right 0
      .write-con
        width 50%
        position absolute
        top 1.45rem
        right 0
        .write-area
          margin-top -0.45rem
        .title
          position relative
          z-index 2
          top 0.3rem
          left 0.38rem
.portrait
  .memory-study_cover
    /deep/
      .write-con
        .title
          text-align center
</style>
